import styled from "styled-components";

const Wrapper = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #080808;
  padding: 24px;

  .login-card {
    width: 400px;
    padding: 36px 32px;
    background: #131313;
    border: 1px solid #292929;
    border-radius: 12px;
  }

  .brand-row {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 22px;
  }

  .brand-logo {
    height: 30px;
  }

  .brand-name,
  .login-title {
    color: #f4f4f5;
  }

  .brand-name {
    font-size: 19px;
    font-weight: 750;
  }

  .login-title {
    margin: 0 0 6px;
  }

  .login-description,
  .field-label {
    color: #b0b0b4;
  }

  .login-description {
    margin-bottom: 24px;
  }

  .login-error {
    margin-bottom: 16px;
  }

  .login-restriction {
    color: #7d7d82;
    font-size: 12px;
    text-align: center;
    margin: 20px 0 0;
  }
`;

export default Wrapper;
